/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileContactResponseFeedback = typeof ProfileContactResponseFeedback[keyof typeof ProfileContactResponseFeedback] | null;


export const ProfileContactResponseFeedback = {
  up: 'up',
  down: 'down',
} as const;
